import React, { useEffect, useState } from 'react';
import { TablesWidget5 } from '../../modules/ctr-r/statusGral/TablesWidget5';
import { TablesWidget6 } from '../../modules/ctr-r/statusGral/TablesWidget6';
import { TablesWidget7 } from '../../modules/ctr-r/statusGral/TablesWidget7';
import { TablesWidget8 } from '../../modules/ctr-r/statusGral/TablesWidget8';
import { useAppSelector } from '../../../redux/hooks';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap'; // Importar Spinner para mostrar mientras carga

const TablesStatuses: React.FC = () => {
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // Estado de loading

  // Validación de permisos y redirección con estado de carga
  useEffect(() => {
    const delay = setTimeout(() => {
      // Primero validar CTXR.GeneralStatus
      if (ListaPermisosTenant.includes('CTXR.GeneralStatus')) {
        // Si el usuario tiene 'CTXR.GeneralStatus', no redirigir a ningún lado, solo detener la carga
        setLoading(false);
      } else if (ListaPermisosTenant.includes('CC.View')) {
        // Si no tiene 'CTXR.GeneralStatus' pero sí 'CC.View', redirigir a Cloud Connectivity
        navigate('/cloudConnectivity');
      } else {
        // Si no tiene ninguno de los permisos, detener la carga
        setLoading(false);
      }
    }, 1000); // Simular un retraso de 1 segundo para la validación de permisos

    // Limpiar el timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate]);

  // Mostrar spinner mientras se validan los permisos
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
      </div>
    );
  }

  return (
    <>
      {/* begin::Row */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col */}
        <div className='col-xl-6'>
          <TablesWidget5 className='card-xl-stretch mb-xl-8' />
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xl-6'>
          <TablesWidget6 className='card-xl-stretch mb-5 mb-xl-8' />
        </div>
        {/* end::Col */}
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col */}
        <div className='col-xl-6'>
          <TablesWidget7 className='card-xl-stretch mb-xl-8' />
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xl-6'>
          <TablesWidget8 className='card-xl-stretch mb-5 mb-xl-8' />
        </div>
        {/* end::Col */}
      </div>
      {/* end::Row */}
    </>
  );
};

export { TablesStatuses };
